// The Kalender looks a person can choose under Minu seaded (views/Me.vue).
// 'vana' is the original calendar; every other look is the new one (lanes,
// working hours on the screen, moving by finger) drawn in its own colours.
// The ids match server service/userPrefs.js — a new look goes in both, plus
// its CSS block under .cal-look-<id> in views/Calendar.vue.
//
//   tint     how much of the technician's colour fills the box (0–1)
//   edge     the coloured lines, as a box-shadow
//   fullTime the time row in the technician's full colour, edge to edge
//   nameLine the technician's name as a line of its own
const LOOKS = [
  {
    value: 'vana',
    text: 'Vana',
    note: 'Kalender nagu see alati on olnud.'
  },
  {
    value: 'praegu',
    text: 'Kahvatu',
    note: 'Uus kalender õrna tooniga: tehniku värv 16%, kitsas serv, väiksem kiri ja tehniku nimi eraldi real.',
    tint: 0.16,
    edge: c => 'inset 3px 0 0 ' + c,
    nameLine: true
  },
  {
    value: 'a',
    text: 'Tugevam toon',
    note: 'Kellaaja rida tehniku täisvärvis, kast 50% toonis, suurem kiri, aadress poolpaksult.',
    tint: 0.5,
    edge: c => 'inset 4px 0 0 ' + c,
    fullTime: true
  },
  {
    value: 'c',
    text: 'Joon üleval',
    note: 'Nagu tugevam toon, aga kellaaja rida pole täidetud: kasti ülaservas on joon tehniku värvis.',
    tint: 0.5,
    edge: c => 'inset 4px 0 0 ' + c + ', inset 0 4px 0 ' + c
  },
  {
    value: 'd',
    text: 'Jooned külgedel',
    note: 'Nagu tugevam toon, aga kellaaja rida pole täidetud: värviline joon on kasti mõlemal küljel.',
    tint: 0.5,
    edge: c => 'inset 4px 0 0 ' + c + ', inset -4px 0 0 ' + c
  }
]

// What Seaded -> Kalender uues kujunduses gives someone who has not chosen.
const defaultLook = (features) => (features && features.calendarPlate ? 'a' : 'vana')

// The look this person sees: their own choice, else the Seaded default.
function effectiveLook (prefs, features) {
  const own = prefs && prefs.calendarLook
  return LOOKS.some(l => l.value === own) ? own : defaultLook(features)
}

const lookOf = (value) => LOOKS.find(l => l.value === value) || LOOKS[2]

// A colour mixed toward white: the work order's tint.
function tint (color, amount) {
  const hex = String(color || '').replace('#', '')
  if (!/^[0-9a-f]{6}$/i.test(hex)) return '#EEF1EF'
  const n = parseInt(hex, 16)
  const mix = [n >> 16 & 255, n >> 8 & 255, n & 255].map(v => Math.round(v * amount + 255 * (1 - amount)))
  return 'rgb(' + mix.join(',') + ')'
}

// Dark or light text, whichever reads better on the colour.
function textOn (color) {
  const hex = String(color || '').replace('#', '')
  if (!/^[0-9a-f]{6}$/i.test(hex)) return '#0F241E'
  const n = parseInt(hex, 16)
  const [r, g, b] = [n >> 16 & 255, n >> 8 & 255, n & 255].map(v => {
    v /= 255
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
  })
  const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b
  return (lum + 0.05) / 0.05 > 1.05 / (lum + 0.05) ? '#0F241E' : '#fff'
}

// A work order's box, its time row and its initials in a look. The Kalender
// and the previews on Minu seaded both draw from these.
const orderStyle = (look, color) => ({ background: tint(color, look.tint), boxShadow: look.edge(color) })
const timeStyle = (look, color) => (look.fullTime && /^#?[0-9a-f]{6}$/i.test(color || '')
  ? { background: '#' + color.replace('#', ''), color: textOn(color) }
  : {})
const initialsStyle = (look, color) => (look.fullTime ? { color } : { background: color })

export { LOOKS, defaultLook, effectiveLook, lookOf, tint, textOn, orderStyle, timeStyle, initialsStyle }
